/**
 * @typedef {{}} Resource
 */
import lodash from "lodash";
import styles from "../index.module.less";
import useViewModel from "../viewModel";
import EmptyUploader from "./EmptyUploader";
import NormalUploader from "./NormalUploader";

/**
 *
 * @param {{
 *   targetBoardId?: number;
 *   onlyCreation?: boolean;
 *   onOk?: (board: Board, resources: Resource[]) => void;
 *   onCancel?: () => void;
 *   onUploadedFileChange?: () => void;
 * }} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function PinUploader(props) {
  const viewModel = useViewModel(props);
  const PUploader =
    !lodash.isEmpty(viewModel.resources) || props.fileList?.length > 0
      ? NormalUploader
      : EmptyUploader;

  return (
    <div
      className={styles.pinUploader}
      data-dialog-title="上传弹窗"
      data-gd-expose="dialog_expose"
    >
      <PUploader {...viewModel} />
    </div>
  );
}
